(function () {
  'use strict';
  if (window.BDSCart) return;
  const pending = new WeakMap();
  let queue = Promise.resolve();
  const emit = (name, detail) => document.documentElement.dispatchEvent(new CustomEvent(name, {bubbles: true, detail}));
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function message(node, text, link) {
    if (!node) return;
    node.textContent = text;
    if (link) {
      const a = document.createElement('a');
      a.href = root() + 'cart';
      a.textContent = ' Warenkorb prüfen';
      node.appendChild(a);
    }
  }
  async function requestJSON(url, options, onResponse) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, {...options, signal: controller.signal});
      if (onResponse) onResponse(response);
      const data = await response.json().catch(error => {
        if (response.ok) throw error;
        return {};
      });
      return {ok: response.ok, status: response.status, data};
    } finally {
      clearTimeout(timeout);
    }
  }
  function validSections(sections, ids) {
    return sections && ids.every(id => typeof sections[id] === 'string' && sections[id].trim());
  }
  async function readCart() {
    const result = await requestJSON(root() + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
    if (!result.ok || !result.data || typeof result.data.item_count !== 'number') throw new Error('cart-refresh');
    return result.data;
  }
  async function publish(cart, items, form, added) {
    const drawer = document.querySelector && document.querySelector('cart-drawer');
    const applied = drawer ? new Promise((resolve, reject) => {
      const finish = event => {
        if (event && event.target !== drawer) return;
        clearTimeout(timeout);
        document.removeEventListener('cart-drawer:refreshed', finish);
        resolve();
      };
      const timeout = setTimeout(() => {
        document.removeEventListener('cart-drawer:refreshed', finish);
        reject(new Error('drawer-refresh'));
      }, 2500);
      document.addEventListener('cart-drawer:refreshed', finish);
    }) : Promise.resolve();
    if (added) (form || document.documentElement).dispatchEvent(new CustomEvent('variant:add', {bubbles: true, detail: {items, cart}}));
    emit('cart:change', {baseEvent: added ? 'variant:add' : 'bds:reconcile', cart});
    await applied;
  }
  async function reconcile(ids, added, items, form) {
    const cart = await readCart();
    let sections = {};
    if (ids.length) {
      const response = await requestJSON(root() + '?sections=' + encodeURIComponent(ids.join(',')), {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok || !validSections(response.data, ids)) throw new Error('section-refresh');
      sections = response.data;
    }
    cart.sections = sections;
    await publish(cart, items, form, added);
    return cart;
  }
  function add(items, options) {
    options = options || {};
    const button = options.button;
    if (button && pending.has(button)) return pending.get(button);
    const wasDisabled = button && button.disabled;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    const task = queue.then(async () => {
      let added = false;
      let sections = [];
      let resultItems = items;
      emit('theme:loading:start');
      try {
        const requested = [];
        emit('cart:prepare-bundled-sections', {sections: requested});
        sections = [...new Set(requested)].slice(0, 5);
        const headers = {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'};
        let body;
        if (options.formData) {
          body = options.formData;
          body.set('sections', sections.join(','));
          body.set('sections_url', location.pathname);
        } else {
          headers['Content-Type'] = 'application/json';
          body = JSON.stringify({items, sections, sections_url: location.pathname});
        }
        let response;
        try {
          response = await requestJSON(root() + 'cart/add.js', {method: 'POST', headers, body}, r => { added = r.ok; });
        } catch (cause) {
          if (added) throw cause;
          const error = new Error('Die Rückmeldung fehlt. Bitte prüfen Sie zuerst den Warenkorb, bevor Sie erneut hinzufügen.');
          error.uncertain = true;
          throw error;
        }
        if (!response.ok) {
          throw new Error((response.data && (response.data.description || response.data.message)) || 'Der Artikel konnte nicht vollständig hinzugefügt werden. Bitte prüfen Sie Menge und Auswahl im Warenkorb.');
        }
        const data = response.data;
        resultItems = data.items || [data];
        const settings = window.themeVariables && window.themeVariables.settings;
        if (settings && (settings.cartType === 'page' || settings.pageType === 'cart')) {
          location.assign(root() + 'cart');
          return {added: true, refreshed: false};
        }
        const cart = await readCart();
        if (!validSections(data.sections || {}, sections)) throw new Error('section-refresh');
        cart.sections = data.sections || {};
        const result = {items: resultItems, cart};
        await publish(cart, resultItems, options.form, true);
        message(options.status, 'In den Warenkorb gelegt.');
        return {added: true, refreshed: true, ...result};
      } catch (error) {
        let cart;
        try { cart = await reconcile(sections, added, resultItems, options.form); } catch (_) {}
        if (added) {
          message(options.status, cart ? 'In den Warenkorb gelegt.' : 'Der Artikel wurde hinzugefügt. Die Warenkorbanzeige konnte nicht aktualisiert werden.', !cart);
          return {added: true, refreshed: !!cart, recovered: !!cart, cart};
        }
        message(options.status, error.message, true);
        error.refreshed = !!cart;
        throw error;
      } finally {
        emit('theme:loading:end');
        if (button) { button.removeAttribute('aria-busy'); button.disabled = wasDisabled; pending.delete(button); }
      }
    });
    if (button) pending.set(button, task);
    queue = task.catch(() => {});
    return task;
  }
  window.BDSCart = {add};
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.closest || !form.closest('product-form[data-bds-cart-form]')) return;
    if (event.defaultPrevented) return;
    event.preventDefault();
    event.stopPropagation();
    const button = event.submitter || form.querySelector('button[type="submit"]');
    if (button && button.hasAttribute('aria-busy')) return;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    const status = form.querySelector('[role="status"]');
    add([], {form, button, status, formData: new FormData(form)}).catch(() => {}).finally(() => {
      const scope = form.closest('[data-bdspd]');
      const data = scope && scope.querySelector('[data-bdspd-json]');
      if (!button || !data) return;
      const variant = JSON.parse(data.textContent).variants.find(v => String(v.id) === form.elements.namedItem('id').value);
      button.disabled = !variant || !variant.available;
    });
  }, true);
  document.addEventListener('click', function (event) {
    const button = event.target.closest && event.target.closest('[data-bdspd] .cross-add[data-variant-id]');
    if (!button || button.disabled) return;
    const status = button.parentNode.querySelector('.cross-status');
    add([{id: Number(button.dataset.variantId), quantity: 1}], {button, status}).then(result => {
      if (result.added) {
        button.textContent = 'Im Warenkorb ✓';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
    }).catch(() => {});
  });
})();
